import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Version } from './version/version.model';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationsService {
    url = `${environment.managerURL}/version-control`;

    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Version[]>(this.url);
    }

    create(version: Version) {
        return this.http.post<Version>(this.url, version);
    }

    update(version: Version) {
        return this.http.put<Version>(
            `${this.url}/${version.version}/deprecate`,
            version
        );
    }

    getById(id: string) {
        return this.http.get<Version>(`${this.url}/id/${id}`);
    }

    delete(id: string) {
        return this.http.delete(`${this.url}/${id}`);
    }

    downloadPlugin(version: string) {
        return this.http.get(`${this.url}/download/${version}`, {
            responseType: 'blob',
        });
    }
}
